export default "__VITE_ASSET__BRNLrD7f__"